import { Hotel, HotelListRequest, HotelWithImages } from "../Types/hotelTypes";
import { PagedList } from "../../Shared/Types/common";
import { hotelsApi } from "./hotelsApi";
import { TagTypes } from "../../../Api/Types/tagTypes";

export const extendedHotelsApi = hotelsApi.injectEndpoints({
  endpoints: (builder) => ({
    getHotelsList: builder.query<PagedList<Hotel>, HotelListRequest>({
      query: (params) => ({
        url: '/hotels/list',
        params,
      }),
      providesTags: [{ type: TagTypes.Hotel, id: 'List' }],
    }),

    getHotelWithImages: builder.query<HotelWithImages, number>({
      query: (id) => `/hotels/${id}/with-images`,
      providesTags: (result, error, id) => [{ type: TagTypes.HotelImages, id }],
    }),

    // NEW: Upload images using new backend API
    uploadHotelImages: builder.mutation<
      { imageIds: string[]; count: number },
      { hotelId: number; files: File[] }
    >({
      query: ({ hotelId, files }) => {
        const formData = new FormData();
        files.forEach((file) => formData.append('Files', file)); // Backend expects "Files" (capital F)
        formData.append('Category', 'Hotel'); // Backend expects "Category"
        formData.append('EntityId', hotelId.toString()); // Backend expects "EntityId"

        return {
          url: '/images/upload-multiple',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error, { hotelId }) => [
        { type: TagTypes.HotelImages, id: hotelId },
      ],
    }),

    // NEW: Delete image by ID (not path)
    deleteHotelImage: builder.mutation<void, { imageId: string; hotelId: number }>({
      query: ({ imageId }) => {
        console.log('[deleteHotelImage] Deleting:', { imageId, url: `/images/${imageId}` });

        return {
          url: `/images/${imageId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, { hotelId }) => [
        { type: TagTypes.HotelImages, id: hotelId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
	useGetHotelsListQuery,
	useUploadHotelImagesMutation,
	useDeleteHotelImageMutation,
	useGetHotelWithImagesQuery,
} = extendedHotelsApi;
